<gp-modal #generateDocumentModal [attr.test-id]="'generateDocumentModal'"
          [closable]="false"
          [hideFooter]="true"
          size="xl">
  <div class="gp-modal-title">
    <h4>{{ modalTitle | translate }}
      <small class="text-sm text-tuna-gray-40 block">
        {{ 'DOCUMENTS.created__by__user' | translate : {user: previewInPdfFormatWithoutSave ? eTemplateData?.createdBy : connectedUser?.fullName} }}
      </small>
    </h4>

    <div *ngIf="showConfirmDiscardChangesMessage" class="alert alert-warning flex-center p-y-sm text-primary">
      <h6 class="m-y-0">
        <em class="fa fa-light fa-exclamation-triangle p-r-sm"></em>
        {{'DOCUMENTS.editor_changes_lost_confirmation_msg' | translate}}
      </h6>
      <div>
        <button (click)="handleDiscardEditorChangesConfirmation(generateDocumentModal)"
                class="btn btn-sm btn-primary m-l-md m-r-sm"
                test-id="confirmButton"
                type="button">
          {{'FORMS.confirm' | translate}}
        </button>
        <button (click)="showConfirmDiscardChangesMessage = false"
                class="btn btn-sm btn-default text-primary btm-sm"
                test-id="cancelButton"
                type="button">
          {{'FORMS.cancel' | translate}}
        </button>
      </div>
    </div>

    <div [ngClass]="{'disabled': showConfirmDiscardChangesMessage}" class="top-action-buttons pull-right">
      <a *ngIf="selectedPreview && !eTemplateDocumentEditorData"
         [attr.test-id]="'downloadButton'"
         [download]="selectedPreview.download"
         [href]="selectedPreview.href"
         class="btn btn-md btn-icon"
         placement="bottom"
         rel="noopener"
         target="_blank"
         tooltip="{{ 'TOOLTIPS.download' | translate }}">
        <i aria-hidden="true" class="fa fa-light fa-download"></i>
      </a>

      <a (click)="downloadEditorContent()"
         *ngIf="eTemplateDocumentEditorData"
         [attr.test-id]="'downloadEditorDataButton'"
         class="btn btn-md btn-icon"
         placement="bottom"
         tooltip="{{ 'TOOLTIPS.download' | translate }}">
        <i aria-hidden="true" class="fa fa-light fa-download text-primary"></i>
      </a>

      <a (click)="handleModalClose(generateDocumentModal)"
         class="btn btn-icon text-muted btn-md"
         placement="bottom"
         test-id="closeModal"
         tooltip="{{ 'FORMS.close' | translate }}">
        <i aria-hidden="true" class="fa fa-light fa-times text-primary"></i></a>
    </div>
  </div>
  <div [ngClass]="{'disabled': showConfirmDiscardChangesMessage}" class="gp-modal-body h-v-8">
    <div [formGroup]="documentDetailsForm" class="document-layout">
      <div class="left-column">
        <div class="document-details padding">
          <h6>
            <span class="font-weight-bold">{{ 'DOCUMENTS.document_details' | translate }}</span>
            <em (click)="isCollapsedByBloc[0] = !isCollapsedByBloc[0]"
                [attr.aria-expanded]="!isCollapsedByBloc[0]"
                [class.fa-angle-down]="!isCollapsedByBloc[0]"
                [class.fa-angle-up]="isCollapsedByBloc[0]"
                aria-controls="document-details"
                class="fa fa-light pull-right text-muted">
            </em>
          </h6>
          <div [collapse]="isCollapsedByBloc[0]" class="m-y-md" id="document-details">
            <div>
              <label for="template">
                {{'DOCUMENTS.template' | translate}}
                <span class="required">*</span>
              </label>
                <gp-tree-select #templateSelection
                                *ngIf="!previewInPdfFormatWithoutSave; else readOnlyDocumentTemplate"
                                id="template"
                                class="form-control"
                                formControlName="template"
                                [tree]="formValuesWrapper?.data"
                                [isSorted]="false"
                                [attr.test-id]="'selectTemplateDropdown'"
                                [placeholder]="'DOCUMENTS.select_template' | translate"
                                (ngModelChange)="templateClicked()"
                                (click-outside)="templateSelection.open = false"
                                ngDefaultControl>
                </gp-tree-select>

              <ng-template #readOnlyDocumentTemplate>
                <input [attr.test-id]="'documentTemplateName'"
                       class="form-control"
                       formControlName="template"
                       type="text"/>
              </ng-template>
            </div>
            <div *ngIf="previewInPdfFormatWithoutSave" class="m-t-md">
              <label class="flex-between" for="title">
                <div>
                  {{'PAYROLL_ONGOING.retro_emp_contract' | translate}}
                  <span class="required">*</span>
                </div>
                <em *ngIf="isEmployeesListLoading" class="fa fa-light fa-spinner fa-spin"></em>
              </label>
              <div>
                <ng-select (typed)="filterEmployees($event)"
                           (selected)="selectedPreview=null"
                           [attr.test-id]="'contractId'"
                           [items]="employeesList"
                           [asyncAutoCompletion]="true"
                           [placeholder]="'Select'"
                           formControlName="contractId"
                           class="form-control">
                </ng-select>

                <ul class="error-list">
                  <li *ngIf="employeesList && employeesList?.length == 0">
                    {{ 'DOCUMENTS.no_employee_contract_for_the_selection' | translate }}
                  </li>
                </ul>
              </div>
            </div>
            <div *ngIf="!previewInPdfFormatWithoutSave" class="m-t-md">
              <label for="employee">
                {{'PAYROLL_RESULT.emp' | translate}}
                <span class="required">*</span>
              </label>
              <div>
                <gp-dropdown-select
                  [attr.test-id]="'employeeSelected'"
                  [customPlaceholderGenerator]="documentsService.placeholderForEmployee"
                  buttonClasses="btn-xs"
                  class="form-control no-b"
                  formControlName="employee"
                  id="employee"
                  ngDefaultControl>
                  <gp-dropdown-option *ngFor="let emp of [employee]" [ngValue]="emp">
                    <div [innerHTML]="documentsService.placeholderForEmployee(emp)"></div>
                  </gp-dropdown-option>
                </gp-dropdown-select>
              </div>
            </div>
            <div *ngIf="!previewInPdfFormatWithoutSave" class="m-t-md">
              <label for="title">
                {{'DOCUMENTS.document_title' | translate}}
                <span class="required">*</span>
              </label>
              <div>
                <input [attr.test-id]="'documentTitle'"
                       [placeholder]="'DOCUMENTS.document_title' | translate"
                       class="form-control"
                       formControlName="title"
                       id="title"
                       type="text"/>
              </div>
            </div>
          </div>
          <hr/>
          <h6 class="p-t-sm">
            <span class="font-weight-bold">{{ 'REPORTS.settings' | translate }}</span>
            <em (click)="collapseBlock(1)"
                [attr.aria-expanded]="!isCollapsedByBloc[1]"
                [class.fa-angle-down]="!isCollapsedByBloc[1]"
                [class.fa-angle-up]="isCollapsedByBloc[1]"
                aria-controls="document-parameters"
                class="fa fa-light pull-right text-muted">
            </em>
          </h6>
          <div [collapse]="isCollapsedByBloc[1]" [contractId]="contractId" [mvelAliases]="mvelAliases"
               class="parameters" gpMvel id="document-parameters">
            <div *ngIf="selectedTemplate?.arguments?.length && !generatedSimpleForm.isFormDisplayed()"
                 class="padding text-center">
              <i aria-hidden="true" class="fa fa-light fa-spinner fa-spin"></i>
            </div>
            <div class="row parameters-generated">
              <gp-generated-simple-form
                [groupZoneDescriptor]="selectedTemplateDescriptor"
                [nbCol]="1"
                (formValuesChanged)="parametersChanged($event)"
                [values]="selectedTemplateValues">
              </gp-generated-simple-form>
            </div>
            <div *ngIf="!selectedTemplate?.arguments?.length"
                 class="padding text-center">
              {{ 'TEMPLATE.no_parameters' | translate }}
            </div>
          </div>
          <form [formGroup]="sendForm">
            <hr/>
            <h6 *ngIf="!previewInPdfFormatWithoutSave" class="p-t-sm">
              <span class="font-weight-bold">{{ 'DOCUMENTS.publish_in_employee_space' | translate }}</span>
              <label class="ui-switch v-m pull-right">
                <input (change)="collapseBlock(2)" formControlName="send"
                       type="checkbox">
                <em></em>
              </label>
            </h6>
            <div [collapse]="isCollapsedByBloc[2]">
              <div class="form-group">
                <label for="receiver">
                  {{'DOCUMENTS.receiver' | translate}}
                  <span class="required">*</span>
                </label>
                <div>
                  <gp-dropdown-select
                    [attr.test-id]="'receiver'"
                    [customPlaceholderGenerator]="documentsService.placeholderForEmployee"
                    buttonClasses="btn-xs"
                    class="form-control no-b"
                    formControlName="receiver"
                    id="receiver"
                    ngDefaultControl>
                    <gp-dropdown-option *ngFor="let emp of [employee]" [ngValue]="emp">
                      <div [innerHTML]="documentsService.placeholderForEmployee(emp)"></div>
                    </gp-dropdown-option>
                  </gp-dropdown-select>
                </div>
              </div>
              <div class="form-group">
                <label for="comment">{{ 'COMMON.comment' | translate }}</label>
                <textarea [rows]="5"
                          class="textarea-control"
                          formControlName="comment"
                          id="comment"
                          placeholder="{{'DOCUMENTS.document_comment_placeholder' | translate}} ...">
              </textarea>
              </div>

              <form [formGroup]="emailForm" autocomplete="off">
                <div class="form-group checkbox">
                  <input formControlName="sendEmail" id="send-email" type="checkbox"/>
                  <label class="m-l-xs" for="send-email">{{ 'DOCUMENTS.send_email' | translate }}</label>
                </div>
                <div class="form-group" gpMvel [contractId]="contractId" [mvelAliases]="emailMvelAliases">
                  <label for="email">
                    {{'DOCUMENTS.email' | translate}}
                    <span class="required">*</span>
                  </label>
                  <div>
                    <input mvel-alias="personalEmail"
                           [attr.test-id]="'email'"
                           [placeholder]="'DOCUMENTS.email' | translate"
                           class="form-control"
                           formControlName="email"
                           id="email"
                           type="text"/>
                  </div>
                  <ul class="error-list"
                      [attr.data-hidden]="emailForm.get('email').valid || !emailForm.get('email').dirty">
                    <li *ngIf="emailForm.get('email').hasError('invalidEmailAddress')">
                      {{ 'FORMS.VALIDATORS.invalid_email' | translate }}
                    </li>
                  </ul>
                </div>
              </form>
            </div>
          </form>

        </div>

        <div class="gp-modal-footer p-a-sm white">
          <div class="btn-bar-wrapper">
            <div class="btn-bar btn-bar-sm btn-bar-align-center">
              <button (click)="preview(generateDocumentModal)"
                      *ngIf="!isPreviewedDataModifiedInEditor else resetEditorChanges"
                      [attr.test-id]="'previewButton'"
                      [disabled]="isPreviewButtonDisabled"
                      class="btn btn-outline-primary"
                      type="button">
                <em *ngIf="!isDocumentPreviewInProgress" class="fa fa-light fa-eye p-x-xs"></em>
                <em *ngIf="isDocumentPreviewInProgress" class="fa fa-light fa-spinner fa-spin pull-right"></em>
                <span class="text-ellipsis">{{ 'REPORTS.preview' | translate }}</span>
              </button>
              <ng-template #resetEditorChanges>
                <button (click)="reset()"
                        [attr.test-id]="'resetButton'"
                        [disabled]="!isPreviewedDataModifiedInEditor"
                        class="btn btn-outline-primary"
                        type="button">
                  <em *ngIf="isDocumentPreviewInProgress" class="fa fa-light fa-spinner fa-spin pull-right"></em>
                  <span class="text-ellipsis">{{ 'COMMON.reset' | translate }}</span>
                </button>
              </ng-template>

              <button (click)="save(generateDocumentModal, sendOption)"
                      *ngIf="!previewInPdfFormatWithoutSave"
                      [attr.test-id]="'saveButton'"
                      [disabled]="!selectedTemplate  || generatedSimpleForm.form?.invalid || documentDetailsForm?.invalid"
                      class="btn btn-fill-primary"
                      type="button">
                <i *ngIf="!isLoadingSave" aria-hidden="true" class="fa fa-light fa-save p-x-xs"></i>
                <i *ngIf="isLoadingSave"
                   aria-hidden="true"
                   class="fa fa-light fa-spinner fa-spin">
                </i>
                <span
                  class="text-ellipsis">{{ sendOption ? ('DOCUMENTS.save_and_publish' | translate) : ('REPORTS.save' | translate) }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="previewInPdfFormat || previewInPdfFormatWithoutSave" class="right-column">
        <skeleton-image *ngIf="isLoadingPreview else everythingIsLoaded"
                        [height]="400"
                        [width]="400"
                        class="padding"
                        effect="wave">
        </skeleton-image>
        <ng-template #everythingIsLoaded>
          <ng-container *ngIf="(errorInPreviewing || errorInSaving || errorInSending || errorLimitReached) else noPreviewErrorBlock">
            <gp-illustrated-message *ngIf="errorInPreviewing"
                                    [text]="'COMMON.something_went_wrong'"
                                    [type]="'SOMETHING_WRONG'">
            </gp-illustrated-message>
            <gp-illustrated-message *ngIf="errorLimitReached"
                                    [type]="'FORBIDDEN'"
                                    [text]="'DOCUMENTS.generate_limit_reached'">
            </gp-illustrated-message>
            <gp-illustrated-message *ngIf="errorInSaving"
                                    [subText]="'DOCUMENTS.save_error_description'"
                                    [text]="'DOCUMENTS.save_error_title'"
                                    [type]="'SOMETHING_WRONG'">
            </gp-illustrated-message>
            <gp-illustrated-message *ngIf="errorInSending"
                                    [subText]="'DOCUMENTS.publish_error_description'"
                                    [text]="'DOCUMENTS.publish_error_title'"
                                    [type]="'SOMETHING_WRONG'">
            </gp-illustrated-message>
          </ng-container>
          <ng-template #noPreviewErrorBlock>
            <gp-illustrated-message *ngIf="!selectedPreview && previewInPdfFormat"
                                    [subText]="'DOCUMENTS.follow_steps'"
                                    [text]="'DOCUMENTS.no_preview'">
            </gp-illustrated-message>
            <gp-illustrated-message *ngIf="!selectedPreview && previewInPdfFormatWithoutSave"
                                    [subText]="'DOCUMENTS.follow_steps_employee_contract'"
                                    [text]="'DOCUMENTS.no_preview_employee_contract'">
            </gp-illustrated-message>
            <gp-illustrated-message *ngIf="errorNotSupportedFormat && selectedPreview"
                                    [text]="'DOCUMENTS.no_supported_format'"
                                    [type]="'NOT_SUPPORTED'">
            </gp-illustrated-message>
          </ng-template>
          <div *ngIf="!errorNotSupportedFormat && selectedPreview && !errorInSaving && !errorInSending"
               [attr.test-id]="'iframe'"
               [innerHtml]="selectedPreview.iframe">
          </div>
        </ng-template>
      </div>
      <div *ngIf="previewInDocumentEditor" class="right-column--editor">
        <skeleton-image *ngIf="isLoadingPreviewInDocumentEditor else everythingIsLoadedForDocumentEditor"
                        [height]="400"
                        [width]="400"
                        class="padding"
                        effect="wave">
        </skeleton-image>
        <ng-template #everythingIsLoadedForDocumentEditor>
          <ng-container *ngIf="(errorInPreviewing || errorInSaving || errorLimitReached) else noPreviewDocumentEditorErrorBlock">
            <gp-illustrated-message *ngIf="errorInPreviewing"
                                    [text]="'COMMON.something_went_wrong'"
                                    [type]="'SOMETHING_WRONG'">
            </gp-illustrated-message>
            <gp-illustrated-message *ngIf="errorInSaving"
                                    [subText]="'DOCUMENTS.save_error_description'"
                                    [text]="'DOCUMENTS.save_error_title'"
                                    [type]="'SOMETHING_WRONG'">
            </gp-illustrated-message>
            <gp-illustrated-message *ngIf="errorLimitReached"
            [type]="'FORBIDDEN'"
            [text]="'DOCUMENTS.generate_limit_reached'">
            </gp-illustrated-message>
          </ng-container>

          <ng-template #noPreviewDocumentEditorErrorBlock>
            <gp-document-editor [eTemplatePreviewData]="eTemplateDocumentEditorData"
                                (editorContentModified)="allowPreviewReset()">
            </gp-document-editor>
          </ng-template>

        </ng-template>
      </div>
    </div>

  </div>

</gp-modal>
